

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {LANGUAGES, loadLanguageAsync} from '@/i18n';

@Component
export default class UiLogout extends Vue {
  languageValue: string = '';

  @Prop()
  value: string = '';

  @Prop()
  menuContentClass: string;

  @Prop({default: false})
  showLabel: boolean;

  @Prop({default: false})
  applyImmediately: boolean;

  @Prop({default: false})
  disabled: boolean;

  languagesList:any =  LANGUAGES;

  mounted() {
    this.languageValue = this.value || this.$i18n.locale;
  }

  handleChange(data:string) {
    this.$emit('change', data)
    this.languageValue = data;
  }

  @Watch('languageValue')
  onValueChanged(value: string) {
    if(this.applyImmediately){
      loadLanguageAsync(this.languageValue);
    }
  }

  @Watch('value')
  onValueChange(value: string) {
    if(!this.applyImmediately){
      this.languageValue = value
    }
  }

  @Watch('$i18n.locale')
  onValueLocale(value: string) {
    this.languageValue = value
  }
}
